/**
 * Moduł obsługujący zdarzenia dataLayer dla testów ankietowych
 */
export default class DataLayerEvents {
    constructor() {
        this.initEventListeners();
    }

    /**
     * Inicjalizacja nasłuchiwania na zdarzenia Livewire
     */
    initEventListeners() {
        document.addEventListener('livewire:init', () => {
            Livewire.on('screening_test_started', (data) => {
                this.pushTestStartEvent(data.test_name, data.test_type);
            });

            Livewire.on('screening_test_end', (data) => {
                this.pushTestEndEvent(data.test_name, data.test_type);
            });

            Livewire.on('generate_lead', (data) => {
                this.pushTestGenerateLeadEvent(data.test_name, data.test_type);
            });

            Livewire.on('contact_form_submit', (data) => {
                this.pushFormSubmit(data.form_name);
            });

            Livewire.on('form_appeal', (data) => {
                this.pushAppealSubmit(data.form_name);
            });

            Livewire.on('add_payment_info', (data) => {
                this.pushPaymentInfo(data.price, data.payment_type, data.target_payment);
            });

            Livewire.on('purchase', (data) => {
                this.pushPurchase(data.price, data.payment_type, data.target_payment, data.transaction_id);
            });
        });
    }

    /**
     * Wysyła zdarzenie rozpoczęcia testu do dataLayer
     *
     * @param {string} testName - Nazwa testu
     * @param {string} testType - Typ testu
     */
    pushTestStartEvent(testName, testType) {
        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
                event: "screening_test_start",
                test_name: testName,
                test_type: testType
            });
        }
    }

    /**
     * Wysyła zdarzenie zakończenia testu do dataLayer
     *
     * @param {string} testName - Nazwa testu
     * @param {string} testType - Typ testu
     */
    pushTestEndEvent(testName, testType) {
        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
                event: "screening_test_end",
                test_name: testName,
                test_type: testType
            });
        }
    }

    /**
     * Wysyła zdarzenie wysłania wiadomości testu do dataLayer
     *
     * @param {string} testName - Nazwa testu
     * @param {string} testType - Typ testu
     */
    pushTestGenerateLeadEvent(testName, testType) {
        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
                event: "generate_lead",
                test_name: testName,
                test_type: testType
            });
        }
    }


    pushFormSubmit(form_name) {
        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
                event: "contact_form_submit",
                form_name: form_name,
            });
        }
    }

    pushAppealSubmit(form_name) {
        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
                event: "appeal",
                form_name: form_name,
            });
        }
    }

    pushPaymentInfo(price, payment_type, target_payment) {
        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
                event: "add_payment_info",
                ecommerce: {
                    currency: 'PLN',
                    value: price,
                    payment_type: payment_type,
                    items: [
                        {
                            item_name: target_payment,
                            price: price,
                        }
                    ]
                }
            });
        }
    }

    pushPurchase(price, payment_type, target_payment, transaction_id) {
        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
                event: "purchase",
                ecommerce: {
                    transaction_id: transaction_id,
                    currency: 'PLN',
                    value: price,
                    items: [
                        {
                            item_name: target_payment,
                            price: price,
                        }
                    ]
                }
            });
        }
    }
}
